import { Build } from "@stencil/core";

export interface ILogger {
  log(message: string): void;
  error(message: string): void;
  warn(message: string): void;
}

class Logger implements ILogger {
  private _prefix: string;

  constructor(prefix: string) {
    this._prefix = prefix;
  }

  public log(message: string) {
    if (Build.isDev) {
      console.log(`[${this._prefix}] ${message}`);
    }
  }

  public error(message: string) {
    if (Build.isDev) {
      console.error(`[${this._prefix}] ${message}`);
    }
  }

  public warn(message: string) {
    if (Build.isDev) {
      console.warn(`[${this._prefix}] ${message}`);
    }
  }
}

export function createLogger(prefix: string) {
  return new Logger(prefix);
}
